import { render } from "./BottomMenu.vue?vue&type=template&id=1e35991e&scoped=true&ts=true"
import script from "./BottomMenu.vue?vue&type=script&lang=ts"
export * from "./BottomMenu.vue?vue&type=script&lang=ts"

import "./BottomMenu.vue?vue&type=style&index=0&id=1e35991e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e35991e"]])

export default __exports__